<template>
  <div>
    <div class="uk-margin" v-if="vehicle.opendamages || vehicle.openDamagesText">
      <div class="uk-text-bold">Offene Schäden</div>
      {{ vehicle.opendamages | euro }} <span v-if="vehicle.openDamagesText"> | {{ vehicle.openDamagesText }}</span>
    </div>
    <div class="uk-margin" v-if="vehicle.previousDamages || vehicle.previousDamagesText">
      <div class="uk-text-bold">Vorschäden</div>
      {{ vehicle.previousDamages | euro }}
      <span v-if="vehicle.previousDamagesText"> | {{ vehicle.previousDamagesText }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: ['vehicle']
}
</script>
